import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import MarketingExpensesComp from './MarketingExpensesComp';

function MarketingExpenses() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <MarketingExpensesComp />
      </div>
    </div>
  );
}

export default MarketingExpenses;
